// Shared class strings for the account UI, matching the dark cards used on the
// Statistics page.

export const cardClass = 'bg-[#1a1a1a] rounded-2xl p-6 border border-[#333] shadow-lg'
export const inputClass =
  'w-full bg-[#1a1a1a] border border-white/10 rounded-lg px-3 py-2 text-white/90 placeholder-white/30 focus:outline-none focus:border-[#ed1c24] disabled:opacity-50'
export const primaryButtonClass =
  'w-full bg-gradient-to-r from-[#b01018] to-[#ed1c24] hover:from-[#c81a22] hover:to-[#ff3b42] text-white px-4 py-2.5 rounded-lg font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed'
export const secondaryButtonClass =
  'w-full bg-[#2a2a2a] hover:bg-[#333] border border-[#444] text-white px-4 py-2.5 rounded-lg font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed'
export const linkButtonClass = 'text-sm text-white/60 underline hover:text-white disabled:opacity-50 disabled:no-underline'
export const errorClass = 'text-sm text-red-400'
